import React from 'react'
import { Navigate } from "react-router-dom"

// Netta Pages
import NettaHome from "../pages/Netta/index"
import ContactPage from "../pages/Netta/ContactPage"
import ServiceDetailPage from "../pages/Netta/ServiceDetailPage"
import AboutPage from "../pages/Netta/AboutPage"

// Special Pages (keep minimal)
import PageError from "../pages/Pages/Special/PageError"
import PageThankYou from "../pages/Pages/Special/PageThankYou"

const routes = [
  // Main Netta Landing Page
  { path: "/", exact: true, component: <NettaHome />, isTopbarDark: false },
  { path: "/index", component: <NettaHome />, isTopbarDark: false },

  // Language routes (TR is default)
  { path: "/tr", component: <NettaHome />, isTopbarDark: false },
  { path: "/en", component: <NettaHome />, isTopbarDark: false },

  // About Page
  { path: "/about", component: <AboutPage />, isTopbarDark: false },
  { path: "/hakkimizda", component: <AboutPage />, isTopbarDark: false },

  // Service Detail Pages
  { path: "/services/:serviceKey", component: <ServiceDetailPage />, isTopbarDark: false },
  { path: "/hizmetler/:serviceKey", component: <ServiceDetailPage />, isTopbarDark: false },

  // Services landing (redirect to home with anchor)
  { path: "/services", component: <Navigate to="/#services" />, isTopbarDark: false },
  { path: "/hizmetler", component: <Navigate to="/#services" />, isTopbarDark: false },

  // Contact
  { path: "/contact", component: <ContactPage />, isTopbarDark: false },
  { path: "/contact-us", component: <ContactPage />, isTopbarDark: false },
  { path: "/iletisim", component: <ContactPage />, isTopbarDark: false },

  // Utility pages
  { path: "/page-error", component: <PageError />, isWithoutLayout: true },
  { path: "/page-thankyou", component: <PageThankYou />, isWithoutLayout: true },

  // Catch all - redirect to home
  { path: "*", component: <Navigate to="/" /> }
]

export default routes
